import React from 'react';
import { HiOutlineExclamationTriangle } from 'react-icons/hi2';

export default function AlertDialog({
  open,
  title = 'Bist du sicher?',
  description = '',
  confirmText = 'Löschen',
  cancelText = 'Abbrechen',
  onConfirm,
  onCancel,
  confirmColor = 'red',
  icon = <HiOutlineExclamationTriangle className="w-10 h-10 text-red-500" />,
}) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div className="bg-white dark:bg-zinc-800 rounded-2xl shadow-2xl max-w-sm w-full p-6 relative animate-fadeIn">
        <div className="flex flex-col items-center text-center">
          <div className="mb-3">{icon}</div>
          <h2 className="text-lg font-bold text-gray-900 dark:text-white mb-2">{title}</h2>
          {description && <p className="text-gray-600 dark:text-gray-300 text-sm mb-6">{description}</p>}
          <div className="flex gap-3 w-full mt-2">
            <button
              className="flex-1 px-4 py-2 rounded-lg bg-gray-200 dark:bg-zinc-700 text-gray-800 dark:text-gray-200 font-medium hover:bg-gray-300 dark:hover:bg-zinc-600 transition"
              onClick={onCancel}
              autoFocus
            >
              {cancelText}
            </button>
            <button
              className={`flex-1 px-4 py-2 rounded-lg font-medium text-white transition shadow-sm hover:shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-${confirmColor}-500 dark:focus:ring-offset-zinc-800 bg-${confirmColor}-600 hover:bg-${confirmColor}-700`}
              onClick={onConfirm}
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
} 